import ArrowLeftIcon from "@untitled-ui/icons-react/build/esm/ArrowLeft";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  IconButton,
  InputAdornment,
  Stack,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Unstable_Grid2 as Grid,
  CardHeader,
  Dialog,
  Box,
  LinearProgress,
} from "@mui/material";
import { Scrollbar } from "../../../components/scrollbar";
import { SeverityPill } from "../../../components/severity-pill";
import { Link, useParams } from "react-router-dom";
import { collection, getFirestore, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import RelatorioPresenca from "../../../pages/RelatorioPresenca";

export function PresencaParlamentares() {
  const params = useParams();
  const roomId = params.id;

  const [presencaParlamentares, setPresencaParlamentares] = useState([]);

  const [open, setOpen] = useState(true);

  const [openDialog, setOnOpenDialog] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "presencaParlamentares"
    );

    onSnapshot(ordersRef, (querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data();

        return { ...data };
      });

      //@ts-ignore
      function compararTimestamps(a, b) {
        return a.momento - b.momento;
      }

      //@ts-ignore
      setPresencaParlamentares(parsedData.sort(compararTimestamps));

      setLoading(true);
    });
  }, []);

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
      }}
    >
      <Dialog fullScreen open={openDialog}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: 80,
            padding: 0,
            margin: 0,
          }}
        >
          <Box
            sx={{
              backgroundColor: "background.paper",
              p: 0,
              padding: 2,
              margin: 0,
              gap: 1,
            }}
          >
            <Button
              color="inherit"
              variant="text"
              startIcon={
                <SvgIcon>
                  <ArrowLeftIcon />
                </SvgIcon>
              }
              sx={{
                border: "1px solid #E0E3E7",
              }}
              onClick={() => {
                setOnOpenDialog(false);
              }}
            >
              Voltar
            </Button>
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1, padding: 0 }}>
          <PDFViewer height="100%" style={{ border: "none" }} width="100%">
            <RelatorioPresenca idSessao={roomId} />
          </PDFViewer>
        </Box>
      </Dialog>

      <Card>
        <CardContent>
          <Grid container spacing={3}>
            <Grid
              sx={{
                width: "100%",
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Stack spacing={1}>
                <Typography variant="h6">Presença dos parlamentares</Typography>
                <Typography color="text.secondary" variant="body2">
                  Atualmente,{" "}
                  {presencaParlamentares.length >= 2
                    ? `${presencaParlamentares.length} parlamentares `
                    : `${presencaParlamentares.length} parlamentar `}{" "}
                  presentes.
                </Typography>
              </Stack>

              <Button
                color="primary"
                variant="outlined"
                size="large"
                onClick={() => {
                  setOnOpenDialog(true);
                }}
              >
                Gerar Relatório
              </Button>
            </Grid>
          </Grid>
        </CardContent>
        <Scrollbar>
          <Table sx={{ minWidth: 400 }}>
            <TableHead>
              <TableRow>
                <TableCell>Parlamentar</TableCell>
                <TableCell>Partido</TableCell>
                <TableCell>Presença</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>

            <TableBody>
              {presencaParlamentares.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Typography variant="subtitle2">{item.nome}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="text.secondary" variant="body2">
                      {item.partido}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="green" variant="subtitle1">
                      Presente
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Scrollbar>
      </Card>
    </Box>
  );
}
